import { Box, Button, Paper, Typography } from '@mui/material';
import React from 'react';
import LockIcon from '@mui/icons-material/Lock';
import { useNavigate } from 'react-router-dom';
import { LINKS, LABEL_UPGRADE_REQUIRED, MSG_RMP_PAID_PLANS_ONLY, BUTTON_TEXT_UPGRADE_PLAN } from '../../app/constants';

const CardLockComponents = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        inset: 0,
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 3
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 360,
          width: '100%',
          textAlign: 'center',
          borderRadius: 3
        }}
      >
        <Box mb={2}>
          <LockIcon />
        </Box>

        <Typography variant="h6" fontWeight={700} mb={1}>
          {LABEL_UPGRADE_REQUIRED}
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          {MSG_RMP_PAID_PLANS_ONLY}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          size="large"
          fullWidth
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            '&:hover': {
              backgroundColor: 'primary.dark'
            }
          }}
          onClick={() => {
            navigate(LINKS.CHANGE_PLAN_LINK);
          }}
        >
          {BUTTON_TEXT_UPGRADE_PLAN}
        </Button>
      </Paper>
    </Box>
  );
};

export default CardLockComponents;
